import { Stack, Typography, CircularProgress, Divider, IconButton, Menu } from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useState } from "react";
import { globalTheme } from "../../styles";
import { useScreenSize } from "../../hooks";
import LinearProgress from "@mui/material/LinearProgress";
import { CustomErrorOverlay } from "./customErrorOverlay";
import { StatTableInterface } from "../../interfaces";

export const StatTable = (props: StatTableInterface) => {
  const { columns, rows, header, secondaryHeader, isLoadingStatTable, isErrorStatTable } = props;
  const [exportMenuOpen, setExportMenuOpen] = useState(false);

  const handleExportClick = () => {
    setExportMenuOpen(true);
  };

  const handleExportClose = () => {
    setExportMenuOpen(false);
  };

  const CustomNoRowOverlay = CustomErrorOverlay;

  const { belowDesktop, belowTablet, belowPhablet } = useScreenSize();

  let stackWidth = "100%";

  if (belowDesktop) {
    stackWidth = "100%";
  } else if (belowTablet) {
    stackWidth = "50%";
  } else if (belowPhablet) {
    stackWidth = "33%";
  }
  const secondaryHeaderText = ` ${secondaryHeader.secondaryHeaderText} ${secondaryHeader.secondaryHeaderCount}`;

  return (
    <Stack
      divider={<Divider />}
      spacing={2}
      padding={1}
      height="400px"
      overflow="hidden"
      sx={{
        border: `10px solid ${globalTheme.border}`,
        width: stackWidth,
      }}
    >
      <Stack spacing={2} direction="row" justifyContent="space-between">
        <Typography align="left">{header}</Typography>
        <Typography align="right">{secondaryHeaderText}</Typography>
      </Stack>

      <DataGrid
        rows={rows}
        columns={columns.map((columns: any) => ({
          ...columns,
          align: "center",
          headerAlign: "center",
          flex: 1,
          width: 100,
        }))}
        pagination
        autoPageSize
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: isErrorStatTable ? CustomNoRowOverlay : undefined,
          loadingOverlay: LinearProgress,
          toolbar: () => (
            <GridToolbarContainer
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <IconButton onClick={handleExportClick}>
                <DownloadIcon />
                <Menu open={exportMenuOpen} onClose={handleExportClose}>
                  <GridToolbarExport />
                </Menu>
              </IconButton>
            </GridToolbarContainer>
          ),
        }}
        loading={isLoadingStatTable}
      />
    </Stack>
  );
};
